// src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import IdentityValidation from "./pages/IdentityValidation";
import IdentityValidationMovil from "./pages/IdentityValidationMovil";
import IdentityEnrollment from "./pages/IdentityEnrollment";
import IdentityEnrollmentMovil from "./pages/IdentityEnrollmentMovil";
import IdentityAuthentication from "./pages/IdentityAuthentication";
import IdentityAuthenticationMovil from "./pages/IdentityAuthenticationMovil";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<IdentityValidation />} />
        <Route path="/IdentityValidation" element={<IdentityValidation />} />
        <Route path="/IdentityValidationMovil" element={<IdentityValidationMovil />} />
        <Route path="/IdentityEnrollment" element={<IdentityEnrollment />} />
        <Route path="/IdentityEnrollmentMovil" element={<IdentityEnrollmentMovil />} />
        <Route path="/IdentityAuthentication" element={<IdentityAuthentication />} />
        <Route path="/IdentityAuthenticationMovil" element={<IdentityAuthenticationMovil />} />
      </Routes>
    </Router>
  );
}

export default App;
